module.exports = __webpack_public_path__ + "media/icons/naped-4x4-blue@2x-8dbd7295.png";